import { useMemo } from "react";
import type { ListRecommendationType } from "app/pages/sales-intelligence/sub-modules/opportunities/types";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import { splitArray } from "app/pages/sales-intelligence/utils/arrays";

type DividedRecommendations = [readonly ListRecommendationType[], readonly ListRecommendationType[]];

/*
    @param recommendations - list of recommendation
    @return Array of lists - [SimilarRecommendation, WorldwideRecommendation]
 */
export function useDivideRecommendations(
    recommendations: readonly ListRecommendationType[],
    countryCode?: number,
): DividedRecommendations {
    return useMemo((): DividedRecommendations => {
        if (countryCode === undefined || countryCode === WORLDWIDE_COUNTRY_ID) {
            return [[], recommendations];
        }

        return splitArray(recommendations, (recommendation) => recommendation.CountryCode === countryCode);
    }, [recommendations, countryCode]);
}
